import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { useTranslation, SUPPORTED_LANGUAGES, SupportedLanguage } from '@/contexts/TranslationContext';
import { Languages, Check } from 'lucide-react';

export const LanguageSelector: React.FC = () => {
  const { currentLanguage, setLanguage, t } = useTranslation();

  const handleLanguageChange = async (language: SupportedLanguage) => {
    await setLanguage(language);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="w-10 h-10 rounded-xl glass border border-white/10 hover:border-primary/50 hover:glow-primary transition-all group"
          title={t('language.select')}
        >
          <Languages className="w-5 h-5 transition-transform group-hover:scale-110" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2 glass border border-white/10 shadow-card">
        <div className="space-y-1">
          <h4 className="text-sm font-medium text-foreground mb-2">
            {t('language.select')}
          </h4>
          {Object.entries(SUPPORTED_LANGUAGES).map(([code, info]) => (
            <Button
              key={code}
              variant="ghost"
              className={`w-full justify-start text-sm h-auto p-2 transition-all ${
                currentLanguage === code
                  ? 'bg-primary/20 text-primary border border-primary/30'
                  : 'hover:bg-white/5 text-foreground'
              }`}
              onClick={() => handleLanguageChange(code as SupportedLanguage)}
            >
              <span className="mr-3 text-lg">{info.flag}</span>
              <span className="flex-1 text-left">{info.name}</span>
              {currentLanguage === code && (
                <Check className="w-4 h-4 ml-2 text-primary" />
              )}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};